import { render, staticRenderFns } from "./LavorazioneViaggioPartenza.vue?vue&type=template&id=584a6533&scoped=true&"
import script from "./LavorazioneViaggioPartenza.vue?vue&type=script&lang=js&"
export * from "./LavorazioneViaggioPartenza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a6533",
  null
  
)

export default component.exports